import { Col, Row, Typography } from 'antd'
import React from 'react'
import { s } from './style'

const { Title } = Typography

const Details: React.FC<{ title: string }> = ({ children, title }) => {
  return (
    <Col span={24}>
      <Row>
        <Title style={s.detail} level={3}>
          {title}
        </Title>
      </Row>
      <Row>{children}</Row>
    </Col>
  )
}

export default Details
